<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="profile-segunda-chamada-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-4" v-if="status">
                                <label for="statusSegundaChamada" class="form-label">Status</label>
                                <Multiselect id="statusSegundaChamada" v-model="status_id" :options="status_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-8 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                                <button type="button" class="btn btn-sm btn-pmes-primary" title="Cadastrar" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                                    <span class="menu-icon">
                                        <i class="fa fa-plus fa-2x bi"></i>
                                    </span>
                                    Cadastrar
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"
                            @tableatualizada="tableatualizada($event)">
                            <th>Disciplina</th>
                            <th>Data Avaliacao</th>
                            <th>Data Solicitacao</th>
                            <th>Status</th>
                            <th>Justificativa</th>
                            <th>Parecer</th>
                            <th class="text-center" style="min-width:170px">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>

        <Cadastro :matricula="matricula" :disciplinas="disciplinas" :status="status" :modal="modal_cadastro"
            @segunda-chamada-criada="refreshTable" />
        <Editar :matricula="matricula" :disciplinas="disciplinas" :status="status" :modal="modal_atualizar"
            :modelo="dados" @segunda-chamada-alterada="refreshTable" />
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CardRh from "@/components/cards/ManzaCard.vue";
import SegundaChamadaService from "@/service/v10/sigap/SegundaChamadaService";
import DisciplinaService from "@/service/v10/sigap/DisciplinaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import { Prop } from "vue-property-decorator";
import $ from "jquery";

@Options({
    name: "ProfileSegundaChamadaIndex",
    components: { CardRh, KDataTable, Multiselect, Cadastro, Editar },
})
export default class ProfileSegundaChamadaIndex extends Vue {
    @Prop() readonly matricula!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service = new SegundaChamadaService();
    public disciplinaService = new DisciplinaService();

    public modal_cadastro = "profile_cadastro_segunda_chamada";
    public modal_atualizar = "profile_atualizar_segunda_chamada";

    public matriculaId: any = null;
    public status_id: any = null;
    public status: any = null;
    public disciplinas: any = null;
    public dados: any = null;

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public limparFiltros() {
        this.status_id = null;
        this.refreshTable();
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public carregarDisciplinas() {
        this.processando = true;
        this.disciplinaService.getTodasDaTurma(this.matricula.turmaId)
            .then(response => {
                this.disciplinas = response?.data ?? [];
                this.processando = false;
            })
            .catch(() => {
                this.disciplinas = [];
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.getStatus();
        this.carregarDisciplinas();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    matriculaId: this.matriculaId,
                    status: this.status_id,
                    search: d.search.value,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: "disciplina", name: "disciplina" },
            { data: "dataAvaliacao", name: "dataAvaliacao" },
            { data: "dataSolicitacao", name: "dataSolicitacao" },
            { data: "status", name: "status" },
            { data: "justificativa", name: "justificativa" },
            { data: "parecer", name: "parecer" },
            { data: "id", name: "id", orderable: false, searchable: false, class: "text-center all" }
        ];

        this.config.columnDefs = [
            {
                targets: 0,
                render: (row) => {
                    return row?.descricao ?? "";
                }
            },
            {
                targets: 1,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row?.nome ? row.nome.replaceAll("_", " ") : "";
                }
            },
            {
                targets: 6,
                render: (row, type, val) => {
                    let buttom = "";
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    return '<button class="btn btn-pmes-warning btn-sm" btn-editar-segunda-chamada ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                        this.modal_atualizar + '"><i class="fa fa-edit"></i> Editar</button>';
                },
            },
        ];
    }

    public tableatualizada() {
        $("[btn-editar-segunda-chamada]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
</script>

<style scoped>
.profile-segunda-chamada-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
